import type {
  DogBreederApplicationAccommodation,
  DogBreederApplicationExperience,
  DogBreederApplicationOtherAnimal,
  DogBreederApplicationTimeAlone,
  DogBreederApplicationTrainer,
  GenderEnum,
} from '@gql/graphql';
import type {
  ApplicationsSuggestionRowItemData,
  HeaderProfileData,
  SelectOption,
} from '@presentation/components';
import type { MouseEventHandler } from 'react';
import type { AuthData } from './components/Auth/types';

export interface ApplicationPageFormValues {
  breedPreferenceId: number;
  motive: string;
  otherAnimals: DogBreederApplicationOtherAnimal[];
  accommodation: DogBreederApplicationAccommodation;
  experiences: DogBreederApplicationExperience[];
  timeAlone: DogBreederApplicationTimeAlone;
  trainers: DogBreederApplicationTrainer[];
  genderPreferences: GenderEnum[] | 'none';
  otherPreferences?: string;
  questions?: string;
}

export type ApplicationPageAuthMethod = 'login' | 'register';

export interface ApplicationPageData {
  applicationForm: any;
  suggestionsForm: any;
  onNextClick: MouseEventHandler;
  currentStep: number;
  checkoutLoading: boolean;
  header: HeaderProfileData;
  auth: AuthData;
  firstName: string;
  breederSpokenLanguages?: string;
  breedOptions: SelectOption<number>[];
  suggestionRows: ApplicationsSuggestionRowItemData[];
  suggestionRowsLoading: boolean;
  draftIsSubmitting: boolean;
  onStepClick(step: number): void;
  onCheckoutClick?(): void;
  onSuggestedBreederClick(breederId: number): void;
}

export interface ApplicationPageProps extends ApplicationPageData {}
